import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import { LocalStorageHandlerService } from "./local-storage-handler.service";

@Injectable()
export class AuthGuard implements CanActivateChild {

    constructor(private _router: Router,
                private lsHandler: LocalStorageHandlerService) {
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const token = LocalStorageHandlerService.getJwtToken();
        if (token === null) {
            this._router.navigate(['/auth', 'login'], {queryParams: {returnUrl: state.url}});
            return false;
        }
        return true;
    }

}
